import React, { useEffect, useState } from "react";
import { API_BASE_URL, API_ENDPOINTS } from '../../constants/index';
import { Badge } from "../ui";

const ConsentStatus = ({ contact }) => {
    const [consent, setConsent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchConsentStatus = async () => {
            try {
                const url = new URL(API_BASE_URL + API_ENDPOINTS.CONCENTCHECK + contact);
                const response = await fetch(url, {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                    },
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const res = await response.json();
                setConsent(res.data.Consent.status);
            } catch (error) {
                console.error('Error fetching consent status:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchConsentStatus();
    }, [contact]);

    if (loading) return <Badge
            variant="info"
        >
            Consent Status: Loading...
        </Badge>;

    return (
        <Badge
            variant={
                consent === 'ALLOWED'
                    ? "success"
                    : "danger"
            }
        >
            Consent Status: {consent}
        </Badge>
    );
}
export default ConsentStatus;